import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const FlowEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"green.600"} />;
};
